var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user" },
    [
      _c(
        "basic-container",
        [
          _c(
            "el-row",
            { attrs: { span: 24 } },
            [
              _c(
                "el-col",
                {
                  staticClass: "user__main",
                  attrs: { md: 24, sm: 24, xs: 24 },
                },
                [
                  _c(
                    "avue-crud",
                    {
                      ref: "crud",
                      attrs: {
                        "before-open": _vm.onHandleBeforeOpen,
                        data: _vm.list,
                        option: _vm.option,
                        page: _vm.page,
                        "table-loading": _vm.listLoading,
                      },
                      on: {
                        "update:page": function ($event) {
                          _vm.page = $event
                        },
                        "on-load": _vm.getList,
                        "search-change": _vm.searchChange,
                        "refresh-change": _vm.refreshChange,
                        "size-change": _vm.sizeChange,
                        "current-change": _vm.currentChange,
                        "row-update": _vm.update,
                        "row-save": _vm.create,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "contactPerson",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.contactPerson)),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "contactPersonMobile",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.contactPersonMobile)),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "name",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.name))]),
                            ]
                          },
                        },
                        {
                          key: "remark",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.remark))]),
                            ]
                          },
                        },
                        {
                          key: "createAt",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.createAt))]),
                            ]
                          },
                        },
                        {
                          key: "menuBefore",
                          fn: function (ref) {
                            var row = ref.row
                            var index = ref.index
                            return [
                              _c(
                                "div",
                                { staticClass: "u-row-center u-flex-wrap" },
                                [
                                  _vm.team_place_edit
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            icon: "el-icon-edit",
                                            type: "text",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleUpdate(
                                                row,
                                                index,
                                                "view"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t查看\n\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.team_place_edit
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "u-m-r-20",
                                          attrs: {
                                            icon: "el-icon-edit",
                                            type: "text",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleUpdate(
                                                row,
                                                index,
                                                "edit"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t编辑\n\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "menuBtn",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "u-row-center u-flex-col u-column-center",
                                  staticStyle: { padding: "0 20px" },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-notebook-2",
                                        type: "text",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showChannelLog(row)
                                        },
                                      },
                                    },
                                    [_vm._v("日志")]
                                  ),
                                  _c("span"),
                                  row.status != 4
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            icon: "el-icon-warning-outline",
                                            type: "text",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleStatus(
                                                row,
                                                _vm.index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                row.status === 1
                                                  ? "停用"
                                                  : "启用"
                                              ) +
                                              "\n\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("span"),
                                  _vm.team_place_del
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            icon: "el-icon-delete",
                                            type: "text",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deletes(row, _vm.index)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t删除\n\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.form,
                        callback: function ($$v) {
                          _vm.form = $$v
                        },
                        expression: "form",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "menuLeft" },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: {
                                change: function ($event) {
                                  return _vm.getList({
                                    parentId: 0,
                                    current: 1,
                                    size: 20,
                                  })
                                },
                              },
                              model: {
                                value: _vm.queryType,
                                callback: function ($$v) {
                                  _vm.queryType = $$v
                                },
                                expression: "queryType",
                              },
                            },
                            [
                              _c("el-radio-button", { attrs: { label: 1 } }, [
                                _vm._v("正常"),
                              ]),
                              _c("el-radio-button", { attrs: { label: 2 } }, [
                                _vm._v("待审核渠道"),
                              ]),
                            ],
                            1
                          ),
                          _vm.team_place_add
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "20px" },
                                  attrs: {
                                    icon: "el-icon-plus",
                                    size: "mini",
                                    type: "primary",
                                  },
                                  on: { click: _vm.onAddChannel },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t新增渠道\n\t\t\t\t\t\t"
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.team_place_edit
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: {
                                    icon: "el-icon-document-copy",
                                    size: "mini",
                                    type: "primary",
                                  },
                                  on: {
                                    click: _vm.openBatchUpdateFollowImport,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t批量更新业务跟进人\n\t\t\t\t\t\t"
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.currentChannel.name + "日志",
            visible: _vm.logDialogVisible,
            width: "80%",
            "before-close": _vm.handleLogClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.logDialogVisible = $event
            },
          },
        },
        [
          _vm.logDialogVisible
            ? _c("channel-log", {
                ref: "channelLogRef",
                attrs: { channelId: _vm.currentChannel.id },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.batchUpdateFollowModal,
            "append-to-body": "",
            title: "批量更新业务跟进人",
            width: "35%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.batchUpdateFollowModal = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "import-main" },
            [
              _c(
                "el-steps",
                {
                  attrs: {
                    active: _vm.batchUpdateFollowStep,
                    "finish-status": "success",
                  },
                },
                [
                  _c("el-step", { attrs: { title: "上传文件" } }),
                  _c("el-step", { attrs: { title: "处理结果" } }),
                ],
                1
              ),
              _vm.batchUpdateFollowStep == 1
                ? _c(
                    "div",
                    { staticClass: "import-content" },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            "before-upload": _vm.beforeUploadFollow,
                            "file-list": _vm.followFileList,
                            limit: 1,
                            "on-remove": _vm.handleFollowRemove,
                            accept: ".xlsx",
                            action: "",
                            drag: "",
                            multiple: "",
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-upload" }),
                          _c(
                            "div",
                            { staticClass: "upload-import-text-main" },
                            [
                              _c("span", [
                                _vm._v("点击上传或拖拽文件到这里进行上传"),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.batchUpdateFollowStep == 2
                ? _c(
                    "div",
                    { staticClass: "import-content" },
                    [
                      _c(
                        "el-result",
                        { attrs: { icon: "success", subTitle: "导入完成!" } },
                        [
                          _c("template", { slot: "title" }, [
                            _c("div", { staticClass: "import-result-title" }, [
                              _vm._v("导入结果"),
                            ]),
                          ]),
                          _c("template", { slot: "extra" }, [
                            _c("div", { staticClass: "import-result-detail" }, [
                              _c(
                                "div",
                                { staticClass: "result-item success" },
                                [
                                  _c("span", { staticClass: "result-label" }, [
                                    _vm._v("成功："),
                                  ]),
                                  _c("span", { staticClass: "result-value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.batchUpdateFollowResult
                                          .successCount || 0
                                      ) + "条"
                                    ),
                                  ]),
                                ]
                              ),
                              _vm.batchUpdateFollowResult.failCount > 0
                                ? _c("div", { staticClass: "result-item" }, [
                                    _c(
                                      "span",
                                      { staticClass: "result-label" },
                                      [_vm._v("失败：")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "result-value error" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.batchUpdateFollowResult
                                              .failCount || 0
                                          ) + "条"
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "result-item" }, [
                                _c("span", { staticClass: "result-label" }, [
                                  _vm._v("总计："),
                                ]),
                                _c("span", { staticClass: "result-value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.batchUpdateFollowResult.totalRows || 0
                                    ) + "条"
                                  ),
                                ]),
                              ]),
                              _vm.batchUpdateFollowResult.errorMessages &&
                              _vm.batchUpdateFollowResult.errorMessages.length >
                                0
                                ? _c("div", { staticClass: "error-messages" }, [
                                    _c("div", { staticClass: "error-title" }, [
                                      _vm._v("错误信息："),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "error-list" },
                                      _vm._l(
                                        _vm.batchUpdateFollowResult
                                          .errorMessages,
                                        function (error, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "error-item",
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(error) +
                                                  "\n\t\t\t\t\t\t\t\t\t"
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.downloadFollowTemplate } }, [
                _vm._v("下载模板"),
              ]),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.batchUpdateFollowModal = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.batchUpdateFollowStep == 1 ? "取消" : "关闭") +
                      "\n\t\t\t"
                  ),
                ]
              ),
              _vm.batchUpdateFollowConfirmShow
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: _vm.followFileList.length == 0,
                        loading: _vm.batchUpdateFollowLoading,
                        type: "primary",
                      },
                      on: { click: _vm.confirmBatchUpdateFollow },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(
                            _vm.batchUpdateFollowStep == 1
                              ? "导入"
                              : "下载未成功数据"
                          ) +
                          "\n\t\t\t"
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }